/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { lazy, Suspense } from 'react';

import { jsx } from '@compiled/react';
import { ErrorBoundary } from 'react-error-boundary';

import { ATI_PRESETS } from '../../../constants';

import { FormLoading } from './Loading';

const GoalCreateWrapperAsync = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_universal-create--goal-create-wrapper" */
		'../../integrations/forms/townsquare/goal'
	).then((module) => ({
		default: module.GoalCreateWrapper,
	})),
);

const TeamCreateWrapperAsync = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_universal-create--team-create-wrapper" */
		'../../integrations/forms/townsquare/team'
	).then((module) => ({
		default: module.TeamCreateWrapper,
	})),
);

function LazyLoadCreateContent({ children }: { children: JSX.Element }) {
	return (
		<ErrorBoundary fallback={null}>
			<Suspense fallback={<FormLoading />}>{children}</Suspense>
		</ErrorBoundary>
	);
}

const CREATE_CONTENT_PRESETS = {
	[ATI_PRESETS.GOAL]: () => (
		<LazyLoadCreateContent>
			<GoalCreateWrapperAsync />
		</LazyLoadCreateContent>
	),
	[ATI_PRESETS.TEAM]: () => (
		<LazyLoadCreateContent>
			<TeamCreateWrapperAsync />
		</LazyLoadCreateContent>
	),
};

export function getCreateContentLoader(ati: string): (() => JSX.Element) | undefined {
	return CREATE_CONTENT_PRESETS[ati as keyof typeof CREATE_CONTENT_PRESETS];
}
